// HKDSE 2019 Paper 1 Knowledge Graph Samples - Complete Combined Set
// Merged from hkdse2019Samples_complete.js and hkdse2019Samples_complete_part2.js

import { hkdse2019Samples_complete } from './hkdse2019Samples_complete.js';
import { hkdse2019Samples_complete_part2 } from './hkdse2019Samples_complete_part2.js';

export const hkdse2019Samples_complete_combined = {
  ...hkdse2019Samples_complete,
  ...hkdse2019Samples_complete_part2
};

export { hkdse2019Samples_complete, hkdse2019Samples_complete_part2 }; 